var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09CE4A5E-0C1E-4AAB-B2E1-9032C819157C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admissions",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "admissionsWorkspaceTasksPanel",
    transform: "translate(-1544.000000, -872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "actionPanel",
    transform: "translate(1055.000000, 795.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigationTabs",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab_Navigation/--Tabs/Icon_+_Label",
    transform: "translate(424.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/People/Fill",
    transform: "translate(65.733333, 27.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt_Bounding_Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04055996,15.0693293 C6.76887996,12.3303187 11.20103,12.3216387 13.94004,15.0499587 L13.94004,15.0499587 L14.1454011,14.8992476 C14.9804204,14.31857 15.9746623,14.0051523 16.99577,14.0042887 C19.7572,14.0019587 21.9976646,16.2386387 22,19.0000587 C22,19.552285 21.552285,20 20.99999,20 L20.99999,20 L15.99999,19.9999995 C15.99999,20.5522845 15.5522749,20.9999995 14.99999,20.9999995 L14.99999,20.9999995 L2.99998996,20.9999995 C2.44770496,20.9999995 1.99998996,20.5522845 1.99998996,19.9999995 L1.99998996,19.9999995 L2.00714501,19.6926829 C2.08573783,17.9559634 2.80849441,16.306221 4.04055996,15.0693293 Z M16.9999999,7 C18.6568499,7 19.9999999,8.34315 19.9999999,10 C19.9999999,11.65685 18.6568499,13 16.9999999,13 L16.9999999,13 L16.8237275,12.9949073 C15.2489238,12.9036606 13.9999999,11.5976772 13.9999999,10 L13.9999999,10 L14.0050926,9.82372764 C14.0963393,8.24892392 15.4023231,7 16.9999999,7 Z M8.99999983,3 C11.2091398,3 12.9999998,4.79086 12.9999998,7 C12.9999998,9.20914 11.2091398,11 8.99999983,11 L8.99999983,11 L8.8003594,10.9951047 C6.68396735,10.8910789 4.99999983,9.14219578 4.99999983,7 L4.99999983,7 L5.00489513,6.80035957 C5.10892089,4.68396753 6.85780346,3 8.99999983,3 Z",
    id: "Fill"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d7d85e4341fd7c4384866ab544b437df.svg";
export { ForwardRef as ReactComponent };